// @flow
import type { AxiosResponse } from "axios";
import dbg from "debug";

const debug = dbg("jp:api:client");

const successLog = (response: AxiosResponse) => {
  const { config, status, headers } = response;

  debug("request:success", status, config?.url, headers);
  return response;
};

export default successLog;
